import { FC, useEffect, useState } from "react";
import { priorAuthorizationProps } from "./types";

interface DrugItem {
  id: number;
  label: string;
  priority: boolean;
  parent_case?: boolean
  child_case?: boolean;
  
}

const PriorAuthorizationModal: FC<priorAuthorizationProps> = ({
  isModalVisible,
  caseId,
  hideModal,
  prescriptionId,
  refreshListing,
  onSubmit,
  addCase,
  addCaseLoading
}) => {
  const [items, setItems] = useState<DrugItem[]>([]);
  const [draggingItem, setDraggingItem] = useState<number | null>(null);

  // Load drug list from addCase
  useEffect(() => {
    if (!addCase?.prescription_attributes?.drug_name) return;

    const arr = addCase.prescription_attributes.drug_name;

    const formatted: DrugItem[] = arr.map((name: any, index: any) => ({
      id: index + 1,
      label: name,
      priority: false,
      parent_case: false,
      child_case: false // add icon logic if needed
    }));

    setItems(formatted);
  }, [addCase]);

  const onDragStart = (id: number) => setDraggingItem(id);

  const onDragOver = (id: number, e: React.DragEvent<HTMLLIElement>) => {
    e.preventDefault();
    if (draggingItem === null || draggingItem === id) return;
    const draggedIndex = items.findIndex((i) => i.id === draggingItem);
    const targetIndex = items.findIndex((i) => i.id === id);
    if (draggedIndex < 0 || targetIndex < 0) return;
    const updated = [...items];
    const draggedItemObj = updated[draggedIndex];
    updated.splice(draggedIndex, 1);
    updated.splice(targetIndex, 0, draggedItemObj);
    setItems(updated);
  };
  const onDragEnd = () => setDraggingItem(null);
  const onSubmitModal = () => {
    const updated = items.map((item, index) => {
      if (index === 0) {
        return {
          ...item,
          priority: true,
          parent_case: true,
          child_case: false
        };
      } else {
        return {
          ...item,
          priority: false,
          parent_case: false,
          child_case: true
        };
      }
    });

    setItems(updated);
    hideModal()
    onSubmit && addCase && onSubmit(addCase,updated)
  }

  return (
    <div
      className={`modal fade ${isModalVisible ? "show show-modal" : ""}`}
      data-bs-backdrop="true"
      aria-hidden="true"
      //onClick={hideModal}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" 
      //onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
              <h4 className="m-0" style={{color:'#3e1052', fontSize:'1.875rem'}}>Drag & Drop to Select Priority</h4>
            <button className="btn-close" aria-label="Close" onClick={hideModal}></button>
          </div>

            <div className="modal-body pt-0">
                <p className="modal-description pt-3">
                    Multiple products are selected. Please indicate the order in which you want us to pursue them for
                    Prior
                    Authorization, beginning with your top priority. If the first product is not covered, we will
                    proceed to
                    the next option in the order you provide.
                </p>
                <table className="table">
                    <thead className="sticky-top">
                        <tr>
                            <th scope="col" style={{paddingLeft:'40px'}}>Drug</th>
                            <th scope="col">Priority</th>
                        </tr>
                    </thead>

                    <tbody className="table-group-divider">
                    {items.map((item, index) => (
                        <tr
                            key={item.id}
                            draggable
                            onDragStart={() => onDragStart(item.id)}
                            onDragOver={(e:any) => onDragOver(item.id, e)}
                            onDragEnd={onDragEnd}
                            className={`drug-row ${draggingItem === item.id ? "dragging" : ""}`}
                        >
                            {/* DRUG Column */}
                            <td>
                                <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-grip-vertical fs-4"></i>
                                    <div className="drug-info">
                                        <div className="fw-bold">{item.label}</div>
                                        <small className="text-muted">Your selected medication</small>
                                    </div>
                                </div>
                            </td>

                            {/* PRIORITY Column */}
                            <td className="align-middle">
                                <span className="badge bg-primary fs-6 px-3">{index + 1}</span>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>

            </div>

            <div className="modal-footer">
            <button
              className="btn btn-primary"
              onClick={onSubmitModal}
              disabled={addCaseLoading}
            >
              Submit Request
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriorAuthorizationModal;
